<template>
    <v-container fluid>
        <v-data-table
            :headers="headers"
            :items="costsFiltered"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
            fixed-header
        >
            <template v-slot:top>
                <v-row
                    no-gutter
                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                    :style="{ 'background-color': '#eeeeee' }"
                >
                    <div class="d-flex">
                        <template>
                            <v-card
                                class="pt-3 pl-2 pr-5 mx-3"
                                min-width="180px"
                                height="75px"
                            >
                                <v-card-text
                                    class="d-flex my-0 py-0 mx-0 px-0"
                                    width="100%"
                                >
                                    <v-chip
                                        class="mb-1 mt-0 mx-2 pt-0 white--text"
                                        :color="insights[0].color"
                                        label
                                        :style="{ height: '50px' }"
                                    >
                                        <v-icon center>
                                            {{ insights[0].icon }}
                                        </v-icon>
                                    </v-chip>
                                    <div class="mb-1 mt-0 pt-0">
                                        <div
                                            class="d-flex mr-0 pr-0 text-capitalize"
                                        >
                                            <span
                                                :style="{
                                                    'font-size': '14px',
                                                    'font-weight': 'bold',
                                                }"
                                                >{{ insights[0].title }}</span
                                            >
                                        </div>
                                        <p class="text-h6 black--text">
                                            {{ costsFiltered.length }}
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </template>
                    </div>

                    <div class="d-flex">
                        <template>
                            <v-card
                                class="pt-3 pl-2 pr-5 mx-3"
                                min-width="180px"
                                height="75px"
                            >
                                <v-card-text
                                    class="d-flex my-0 py-0 mx-0 px-0"
                                    width="100%"
                                >
                                    <v-chip
                                        class="mb-1 mt-0 mx-2 pt-0 white--text"
                                        :color="insights[1].color"
                                        label
                                        :style="{ height: '50px' }"
                                    >
                                        <v-icon center>
                                            {{ insights[1].icon }}
                                        </v-icon>
                                    </v-chip>
                                    <div class="mb-1 mt-0 pt-0">
                                        <div
                                            class="d-flex mr-0 pr-0 text-capitalize"
                                        >
                                            <span
                                                :style="{
                                                    'font-size': '14px',
                                                    'font-weight': 'bold',
                                                }"
                                                >{{ insights[1].title }}</span
                                            >
                                        </div>
                                        <p class="text-h6 black--text">
                                            {{ milestonesInfo().active }}
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </template>
                    </div>
                    <div class="d-flex">
                        <template>
                            <v-card
                                class="pt-3 pl-2 pr-5 mx-3"
                                min-width="180px"
                                height="75px"
                            >
                                <v-card-text
                                    class="d-flex my-0 py-0 mx-0 px-0"
                                    width="100%"
                                >
                                    <v-chip
                                        class="mb-1 mt-0 mx-2 pt-0 white--text"
                                        :color="insights[2].color"
                                        label
                                        :style="{ height: '50px' }"
                                    >
                                        <v-icon center>
                                            {{ insights[2].icon }}
                                        </v-icon>
                                    </v-chip>
                                    <div class="mb-1 mt-0 pt-0">
                                        <div
                                            class="d-flex mr-0 pr-0 text-capitalize"
                                        >
                                            <span
                                                :style="{
                                                    'font-size': '14px',
                                                    'font-weight': 'bold',
                                                }"
                                                >{{ insights[2].title }}</span
                                            >
                                        </div>
                                        <p class="text-h6 black--text">
                                            {{ milestonesInfo().completed }}
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </template>
                    </div>
                    <div class="d-flex">
                        <template>
                            <v-card
                                class="pt-3 pl-2 pr-5 mx-3"
                                min-width="180px"
                                height="75px"
                            >
                                <v-card-text
                                    class="d-flex my-0 py-0 mx-0 px-0"
                                    width="100%"
                                >
                                    <v-chip
                                        class="mb-1 mt-0 mx-2 pt-0 white--text"
                                        :color="insights[3].color"
                                        label
                                        :style="{ height: '50px' }"
                                    >
                                        <v-icon center>
                                            {{ insights[3].icon }}
                                        </v-icon>
                                    </v-chip>
                                    <div class="mb-1 mt-0 pt-0">
                                        <div
                                            class="d-flex mr-0 pr-0 text-capitalize"
                                        >
                                            <span
                                                :style="{
                                                    'font-size': '14px',
                                                    'font-weight': 'bold',
                                                }"
                                                >{{ insights[3].title }}</span
                                            >
                                        </div>
                                        <p class="text-h6 black--text">
                                            {{
                                                milestonesInfo().percentage.toFixed(
                                                    1
                                                )
                                            }}
                                            %
                                        </p>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </template>
                    </div>
                </v-row>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.description`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByDescription"
                    dense
                />
            </template>
            <template v-slot:[`header.type`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByType"
                    dense
                />
            </template>
            <template v-slot:[`header.quoteNumber`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByQuote"
                    dense
                />
            </template>
            <!--ITEMS-->
            <template v-slot:body>
                <draggable
                    :list="costsFiltered"
                    tag="tbody"
                    @change="onMoveCallback"
                    handle=".handle"
                    :disabled="hasActiveFilters"
                >
                    <tr
                        v-for="item in costsFiltered"
                        :key="rowKey(item)"
                        @mouseover="handle = rowKey(item)"
                        @mouseleave="handle = undefined"
                    >
                        <td class="handle">
                            <div class="d-flex justify-center">
                                <v-btn
                                    small
                                    icon
                                    :class="{
                                        invisible: rowKey(item) != handle,
                                    }"
                                    :style="{ cursor: 'grab !important' }"
                                    :disabled="hasActiveFilters"
                                >
                                    <v-icon>mdi-pan-vertical</v-icon>
                                </v-btn>
                            </div>
                        </td>
                        <td class="text-center">{{ item.quoteNumber }}</td>
                        <td>
                            <div class="d-flex justify-center">
                                <p>
                                    {{ item.reference }}
                                </p>
                            </div>
                        </td>
                        <td class="text-right">
                            <div class="my-4">
                                <p>
                                    {{
                                        formatCurrency(
                                            globalCurrency || 'COP',
                                            item.salePrice
                                        )
                                    }}
                                </p>
                            </div>
                        </td>
                        <td
                            v-for="milestone in milestones"
                            :key="`${rowKey(item)}-${milestone.id}`"
                            class="text-center"
                        >
                            <div class="d-flex justify-center align-center">
                                <p
                                    v-if="
                                        item.formatMilestones &&
                                            item.formatMilestones[milestone.id]
                                    "
                                    :style="{ margin: 0 }"
                                    :class="{
                                        'text-gray':
                                            dateDiff(
                                                item.formatMilestones[
                                                    milestone.id
                                                ].date
                                            ) > 20 &&
                                            item.formatMilestones[milestone.id]
                                                .percentage < 100,
                                        'text-orange':
                                            dateDiff(
                                                item.formatMilestones[
                                                    milestone.id
                                                ].date
                                            ) > 6 &&
                                            dateDiff(
                                                item.formatMilestones[
                                                    milestone.id
                                                ].date
                                            ) < 20 &&
                                            item.formatMilestones[milestone.id]
                                                .percentage < 100,
                                        'text-red':
                                            dateDiff(
                                                item.formatMilestones[
                                                    milestone.id
                                                ].date
                                            ) < 7 &&
                                            item.formatMilestones[milestone.id]
                                                .percentage < 100,
                                        'text-green':
                                            item.formatMilestones[milestone.id]
                                                .percentage == 100,
                                    }"
                                >
                                    {{
                                        formatDate(
                                            item.formatMilestones[milestone.id]
                                                .date._seconds ||
                                                item.formatMilestones[
                                                    milestone.id
                                                ].date.seconds
                                        )
                                    }}
                                </p>
                                <v-btn
                                    x-small
                                    icon
                                    class="d-flex justify-center mt-0 ml-1"
                                    @click="
                                        openMilestoneDialog(item, milestone.id)
                                    "
                                >
                                    <v-icon>
                                        {{
                                            item.formatMilestones[milestone.id]
                                                ? item.formatMilestones[
                                                      milestone.id
                                                  ].percentage == 100
                                                    ? 'mdi-eye'
                                                    : 'mdi-pencil'
                                                : 'mdi-plus'
                                        }}</v-icon
                                    >
                                </v-btn>
                            </div>
                        </td>
                    </tr>
                </draggable>
            </template>
        </v-data-table>
        <!--MILESTONE DETAILS-->
        <v-dialog
            v-model="milestoneDialog"
            :retain-focus="false"
            persistent
            width="1300px"
        >
            <MilestoneDetails
                v-if="milestoneDialog"
                :selectedMilestone="selectedMilestone"
                :originalCost="selectedCost"
                :milestones="milestones"
                :settingId="settingId"
                :users="users"
                @replaceMilestones="replaceMilestones"
                @close="closeMilestoneDialog"
            />
        </v-dialog>
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import API from '@/services/api'
import Draggable from 'vuedraggable'

export default {
    name: 'QuoteMilestonesLegacy',
    props: {
        project: Object,
        users: Array,
    },
    components: {
        MilestoneDetails: () =>
            import('@/components/Milestones/MilestoneDetails.vue'),
        Draggable,
    },
    data: () => ({
        loading: false,
        milestones: [],
        headers: [
            {
                text: '',
                value: 'handle',
                sortable: false,
            },
            {
                text: 'QUOTE',
                value: 'quoteNumber',
                sortable: false,
                align: 'center',
            },
            {
                text: 'SCOPE',
                value: 'description',
                sortable: false,
                align: 'left',
            },
            {
                text: 'PRICE',
                value: 'salePrice',
                sortable: false,
                align: 'right',
            },
        ],
        searchByDescription: undefined,
        searchByType: undefined,
        searchByQuote: undefined,
        milestonesKey: 'milestones',
        selectedCost: {},
        selectedMilestone: null,
        milestoneDialog: false,
        settingId: null,
        costs: [],
        milestonesRowOrder: [],
        handle: undefined,
        insights: [
            {
                color: '#3498DB',
                icon: 'mdi-format-list-bulleted',
                iconColor: '#1A5276',
                title: 'SCOPES',
            },
            {
                color: '#ffa414',
                icon: 'mdi-flag-triangle',
                iconColor: '#1A5276',
                title: 'MILESTONES',
            },
            {
                color: '#20844c',
                icon: 'mdi-check',
                iconColor: '#2874A6',
                title: 'COMPLETED',
            },
            {
                color: '#F08845',
                icon: 'mdi-percent-outline',
                iconColor: 'primary',
                title: 'PERCENTAGE',
            },
        ],
        globalCurrency: null,
    }),
    async mounted() {
        try {
            this.loading = true
            this.milestonesRowOrder = this.project.milestonesRowOrder
                ? [...this.project.milestonesRowOrder]
                : []
            const {
                data: { settings },
            } = await API.getSettings()
            const setting = settings.find(
                setting => setting.name.toLowerCase() == 'quotes'
            )
            const indexExchanges = settings.findIndex(
                u => u.name === 'Exchange'
            )
            this.globalCurrency = settings[indexExchanges].globalCurrency
            if (setting) {
                this.settingId = setting.id
                if (setting[this.milestonesKey]) {
                    this.milestones = setting[this.milestonesKey]
                }
            }

            if (this.milestones && this.milestones.length > 0) {
                this.milestones.forEach(milestone => {
                    this.headers.push({
                        text: milestone.name.toUpperCase(),
                        value: 'milestone',
                        id: milestone.id,
                        sortable: false,
                        align: 'center',
                    })
                })
            }
            //get costs
            const quotes = []
            this.project.quotes.forEach(q =>
                quotes.push({ id: q.split('/')[0], number: q.split('/')[1] })
            )
            for (const quote of quotes) {
                const costs = await API.getCosts(quote.id)
                costs.forEach(c => {
                    c.quoteId = quote.id
                    c.quoteNumber = quote.number
                })
                this.costs.push(...costs)
            }
            // filter only costs with type
            for (let i = this.costs.length - 1; i >= 0; i--) {
                if (!this.costs[i].type) {
                    this.costs.splice(i, 1)
                }
                if (
                    isNaN(this.costs[i].quoteNumber) ||
                    !this.costs[i].quoteNumber
                ) {
                    this.costs[i].quoteNumber = '-'
                }
            }
            this.costs = this.costs.filter(obj => obj.type === 'cost')
            this.applyMilestonesRowOrder()
            this.formatMilestones()
        } catch (error) {
            this.setErrorItems({
                name: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    computed: {
        hasActiveFilters() {
            return !!(
                this.searchByDescription ||
                this.searchByType ||
                this.searchByQuote
            )
        },
        costsFiltered() {
            const conditions = []
            if (this.searchByDescription) {
                conditions.push(this.filterByDescription)
            }
            if (this.searchByType) {
                conditions.push(this.filterByType)
            }
            if (this.searchByQuote) {
                conditions.push(this.filterByQuote)
            }
            if (conditions.length > 0) {
                return this.costs.filter(cost => {
                    return conditions.every(condition => {
                        return condition(cost)
                    })
                })
            }
            return this.costs
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        rowKey(item) {
            return `${item.quoteId}/${item.id}`
        },
        defaultCostsSort(a, b) {
            if (a.quoteId !== b.quoteId) {
                return a.quoteId > b.quoteId ? 1 : -1
            }
            if (a.type !== b.type) {
                return a.type < b.type ? 1 : -1
            }
            return (a.index || 0) - (b.index || 0)
        },
        applyMilestonesRowOrder() {
            const order = this.milestonesRowOrder || []
            if (!order.length) {
                this.costs.sort(this.defaultCostsSort)
                return
            }
            const orderMap = new Map(order.map((key, index) => [key, index]))
            const known = []
            const unknown = []
            this.costs.forEach(cost => {
                const key = this.rowKey(cost)
                if (orderMap.has(key)) {
                    known.push(cost)
                } else {
                    unknown.push(cost)
                }
            })
            known.sort(
                (a, b) =>
                    orderMap.get(this.rowKey(a)) - orderMap.get(this.rowKey(b))
            )
            unknown.sort(this.defaultCostsSort)
            this.costs = [...known, ...unknown]
        },
        async onMoveCallback(evt) {
            if (!evt.moved || this.hasActiveFilters) {
                return
            }
            try {
                const costIds = this.costs.map(cost => this.rowKey(cost))
                this.milestonesRowOrder = costIds
                if (this.project) {
                    this.$set(this.project, 'milestonesRowOrder', costIds)
                }
                await API.updateMilestonesRowOrder(this.project.id, costIds)
            } catch (error) {
                this.setErrorItems({
                    name: this.$options.name,
                    message: error.message,
                })
            }
        },
        filterByDescription(item) {
            return item.reference
                .toLowerCase()
                .includes(this.searchByDescription.toLowerCase())
        },
        filterByType(item) {
            return item.type
                .toLowerCase()
                .includes(this.searchByType.toLowerCase())
        },
        filterByQuote(item) {
            return item.quoteNumber
                .toLowerCase()
                .includes(this.searchByQuote.toLowerCase())
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('YYYY/MM/DD')}`
        },
        dateDiff(date) {
            const days = moment.unix(date._seconds).diff(moment(), 'days')
            return days
        },
        openMilestoneDialog(item, milestoneId) {
            this.selectedCost = _.cloneDeep(item)
            this.selectedMilestone = milestoneId
            this.milestoneDialog = true
        },
        closeMilestoneDialog() {
            this.selectedCost = _.cloneDeep({})
            this.selectedMilestone = null
            this.milestoneDialog = false
        },
        replaceMilestones({ costId, milestones }) {
            const costIndex = this.costs.findIndex(c => c.id == costId)
            if (costIndex > -1) {
                this.costs[costIndex].milestones = milestones
                this.formatMilestones()
            }
        },
        formatMilestones() {
            this.costs.forEach(cost => {
                let formatMilestones = {}
                if (cost.milestones) {
                    cost.milestones.forEach(milestone => {
                        if (typeof milestone.date == 'string') {
                            const date = new Date(milestone.date)
                            const _seconds = Math.floor(date.getTime() / 1000)
                            milestone.date = { _seconds }
                        }
                        formatMilestones[milestone.id] = milestone
                    })
                }
                cost.formatMilestones = formatMilestones
            })
        },
        formatCurrency(currency, value) {
            if (currency && value) {
                const formattedValue = new Intl.NumberFormat('de-DE', {
                    style: 'currency',
                    currency: currency,
                    maximumFractionDigits: 0,
                }).format(+value)
                if (Math.abs((+value || 0).toFixed(0)) == 0) {
                    return '-'
                }
                return formattedValue
            } else if (currency && !value) {
                return '-'
            }
        },
        getScopeValue(cost) {
            return Number(cost.salePrice2 || cost.salePrice || 0)
        },
        getScopeProgress(cost) {
            if (!cost.milestones || cost.milestones.length === 0) {
                return 0
            }
            const total = cost.milestones.reduce(
                (accumulator, milestone) =>
                    accumulator + Number(milestone.percentage || 0),
                0
            )
            return total / cost.milestones.length
        },
        milestonesInfo() {
            let milestonesInfo = { active: 0, completed: 0, percentage: 0 }
            let weightedProgress = 0
            let totalWeight = 0
            let equalProgress = 0

            this.costsFiltered.forEach(c => {
                if (c.milestones) {
                    milestonesInfo.active += c.milestones.length
                    milestonesInfo.completed += c.milestones.reduce(
                        (accumulator, milestone) =>
                            accumulator + (milestone.percentage == 100 ? 1 : 0),
                        0
                    )
                }

                const scopeProgress = this.getScopeProgress(c)
                const scopeValue = this.getScopeValue(c)

                // Include every scope so missing progress counts as 0%
                weightedProgress += scopeProgress * scopeValue
                totalWeight += scopeValue
                equalProgress += scopeProgress
            })

            if (totalWeight > 0) {
                milestonesInfo.percentage = weightedProgress / totalWeight
            } else if (this.costsFiltered.length > 0) {
                // Fallback when scopes have no sale price
                milestonesInfo.percentage =
                    equalProgress / this.costsFiltered.length
            }

            return milestonesInfo
        },
    },
}
</script>

<style>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
}
.v-input .v-label {
    font-size: 12px;
}
.text-gray {
    color: rgb(95, 95, 95);
    font-weight: bold;
}
.text-orange {
    color: orange;
    font-weight: bold;
}
.text-green {
    color: green;
    font-weight: bold;
}
.text-red {
    color: red;
    font-weight: bold;
}
.invisible {
    visibility: hidden;
}
</style>
